<template>
  <el-container>
    <el-aside
      v-if="!isMobile"
      class="sidebar"
      :width="width"
    >
      <div class="vul-detail-aside">
        <router-link
          tabindex="-1"
          :to="{name: 'home-page'}"
          class="logo"
        >
          <img
            v-if="!collapse"
            class="logoImg"
            src="@assets/logo-text.png"
            alt="zast.ai"
          />
          <img
            v-else
            class="logoImg-s"
            src="@assets/logo.png"
            alt="zast.ai"
          />
        </router-link>
        <div
          class="vulList"
          v-if="!collapse"
        >
          <div
            v-for="vul in vulList"
            :key="vul.id"
            class="vulList-item"
            :class="{'active': vul.vulId === vulId}"
            @click="handleVulClick(vul.vulId)"
          >
            <span :class="['vulTag', vul.severity.toLowerCase()]"></span>
            <span class="vulList-item-text">{{ vul.category }}</span>
          </div>
        </div>
        <div
          class="folderWrapper"
          @click="toggleSidebar"
        >
          <img
            :class="['folderImg', {unfolderImg: collapse}]"
            src="@assets/icon/double-arrow-left.png"
            alt=""
          >
        </div>
      </div>
    </el-aside>
    <el-main v-loading="loading">
      <div class="vul-detail-main">
        <div class="vul-detail-main-header">
          <div class="vul-detail-main-header-title">
            <i
              class="el-icon-warning"
              :style="{fontSize: isMobile ? '16px' : '24px'}"
            ></i>
            <span
              class="vul-detail-main-header-title-text"
              :style="{fontSize: isMobile ? '12px' : '16px'}"
            >{{ $t('vulDetail.tips', { appTitle: APP_TITLE }) }}</span>
          </div>
          <div
            v-if="isMobile"
            class="vul-detail-main-header-nav"
          >
            <el-button
              :disabled="currentIndex === 0"
              class="nav-btn"
              type="text"
              size="medium"
              @click="handleNavClick('previous')"
            >
              previous
            </el-button>
            <span>{{ currentIndex + 1 }}/{{ vulList.length }}</span>
            <el-button
              :disabled="currentIndex === vulList.length - 1"
              class="nav-btn"
              type="text"
              size="medium"
              @click="handleNavClick('next')"
            >
              next
            </el-button>
          </div>
        </div>
        <div class="vul-detail-main-content">
          <VulInfo :vul="vulDetail" />
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { getVulShare, getVulShareDetail } from '@/api/base';
import VulInfo from '@/components/vul-info';

export default {
  name: 'VulDetail',
  components: {
    VulInfo,
  },
  data() {
    return {
      collapse: false,
      taskId: this.$route.params.taskId,
      shareId: this.$route.params.shareId,
      vulId: this.$route.query.vulId,
      vulList: [],
      vulDetail: {},
      loading: true,
      currentIndex: 0,
    };
  },
  computed: {
    width() {
      return this.collapse ? '80px' : '300px';
    },
  },
  watch: {
    vulId: {
      handler(newVal) {
        if (newVal) {
          this.getVulShareDetail(newVal);
        }
      },
      immediate: true,
    },
  },
  methods: {
    toggleSidebar() {
      this.collapse = !this.collapse;
    },
    handleNavClick(type) {
      if (type === 'previous') {
        this.currentIndex--;
      } else {
        this.currentIndex++;
      }

      this.vulId = this.vulList[this.currentIndex]?.vulId;
    },
    async getVulShare() {
      const res = await getVulShare(this.shareId);
      this.vulList = res.data;

      if (!this.vulId) {
        this.vulId = res.data[0].vulId;
      }
    },
    async getVulShareDetail(vulId) {
      this.loading = true;
      const res = await getVulShareDetail(this.shareId, vulId);
      this.vulDetail = res;
      this.loading = false;
    },
    handleVulClick(vulId) {
      this.vulId = vulId;
    },
  },
  mounted() {
    this.getVulShare();
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  position: relative;
  border-radius: 6px;
  margin: 20px 0 20px 20px;
  padding: 4px 0;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.vul-detail-aside {
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;

  img {
    width: 120px;
    height: fit-content;
  }

  .logoImg-s {
    width: 24px;
    height: fit-content;
  }
}

.vul-detail-main {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 6px;
  padding: 16px;
  box-sizing: border-box;
  height: 100%;
}

.vul-detail-main-header-title {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  max-width: 800px;
  padding: 0 32px;

  .vul-detail-main-header-title-text {
    margin-left: 10px;
    font-size: 16px;
    color: #666;
  }
}

.vul-detail-main-content {
  flex: 1;
  overflow: auto;
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.vulList {
  margin: 0 16px;
  border: 1px solid #ebeef5;
  padding: 16px;
  flex: 1;
}

.vulList-item {
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 8px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  color: #666;

  &.active {
    background: #90ee90;
    color: #000;
  }

  &:not(:last-child) {
    margin-bottom: 10px;
  }
}

.vulTag {
  display: inline-block;
  margin-right: 8px;
  margin-left: -8px;
  width: 6px;
  height: 100%;
  font-size: 14px;
}

.vulList-item-text {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vulTag.low {
  background: #67c23a;
}

.vulTag.medium {
  background: #e6a23c;
}

.vulTag.high {
  background: #f56c6c;
}

.vulTag.critical {
  background: #951d1d;
}

.folderWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 56px;
  margin-top: auto;

  .folderImg {
    width: 20px;
    height: 20px;
  }

  .unfolderImg {
    transform: rotate(180deg);
  }

  .foldIcon {
    font-size: 20px;
    color: #2b2b2b;
  }

  .folderWrapper {
    &:hover {
      outline: 0;
      background-color: #ecf5ff;
    }
  }
}

.vul-detail-main-header-nav {
  margin-top: 16px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    text-align: center;
    flex: 1;
    margin: 0 8px;
    font-size: 16px;
    font-weight: 600;
  }

  .nav-btn {
    padding: 0;
    width: 60px;
  }
}

.is-mobile .vul-detail-main-content {
  padding: 0;
}

.is-mobile .vul-detail-main-header-title {
  padding: 0 16px;
}
</style>
